var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconSubtitlesSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconSubtitles",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M213.333 0C95.513 0 0 95.513 0 213.333V1706.67C0 1824.49 95.513 1920 213.333 1920H1706.67c117.82 0 213.33-95.51 213.33-213.33V213.333C1920 95.513 1824.49 0 1706.67 0H213.333ZM320 1200c0-44.18 35.817-80 80-80h693.33c44.19 0 80 35.82 80 80s-35.81 80-80 80H400c-44.183 0-80-35.82-80-80Zm1066.67 0c0-44.18 35.81-80 80-80H1520c44.18 0 80 35.82 80 80s-35.82 80-80 80h-53.33c-44.19 0-80-35.82-80-80Zm-640.003 320c0-44.18 35.817-80 80-80H1520c44.18 0 80 35.82 80 80s-35.82 80-80 80H826.667c-44.183 0-80-35.82-80-80ZM320 1520c0-44.18 35.817-80 80-80h53.333c44.183 0 80 35.82 80 80s-35.817 80-80 80H400c-44.183 0-80-35.82-80-80Z"
      }))
    });
  }
}
IconSubtitlesSolid.glyphName = 'subtitles';
IconSubtitlesSolid.variant = 'Solid';
IconSubtitlesSolid.displayName = 'IconSubtitlesSolid';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconSubtitlesSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconSubtitlesSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconSubtitlesSolid;
export { IconSubtitlesSolid };